import React from 'react'
import PropTypes from 'prop-types'
import { Container, Columns, Column, Button } from '@resurs/midas-react'

const SettingsPanel = ({ header, buttons, children }) => (
  <Container>
    <Columns>
      <Column col12 noPadding>
        <section
          id="toolbar"
          style={{
            minHeight: '6.8rem',
            height: '6.8rem',
            alignItems: 'center',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
            padding: '1rem',
            background: 'rgba(250,250,250,1)',
          }}
        >
          <div style={{ marginLeft: '1rem', fontWeight: '600' }}>{header}</div>
          <div style={{ display: 'flex' }}>
            {buttons.map(b => (
              <div key={b.text} style={{ marginRight: '1rem' }}>
                <Button
                  {...b}
                  size="small"
                  onClick={() => {
                    b.action()
                  }}
                />
              </div>
            ))}
          </div>
        </section>
      </Column>
      <Column col12 noPadding>
        <section
          id="font-settings"
          style={{
            minHeight: '6.8rem',
            alignItems: 'center',
            display: 'flex',
            flexWrap: 'wrap',
            borderTop: 'none',
            padding: '1rem',
            background: 'white',
          }}
        >
          {children}
        </section>
      </Column>
    </Columns>
  </Container>
)

SettingsPanel.propTypes = {
  header: PropTypes.string,
  buttons: PropTypes.array,
  children: PropTypes.any,
}

SettingsPanel.defaultProps = {
  header: null,
  buttons: [],
  children: null,
}

export default SettingsPanel
